import styled from 'styled-components';
import Ico24 from '../Ico24';
import { Typ30, Typ60 } from '../Typ';

export const ElementWrapper = styled.div`
  height: 60px;
  display: flex;
  flex-direction: column;
  background: ${props => (props.theme === 'dark' ? '#B0BEC5' : '#fff')};
`;
export const ValueWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;
export const ValueText = styled(Typ60)`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const Icon = styled(Ico24)`
  margin: 8px 8px 8px 0;
`;
export const LabelText = styled(Typ30)`
  text-align: center;
  color: ${props => (props.theme === 'dark' ? '#fff' : '#90A4AE')};
  display: flex;
  justify-content: center;
`;
